import { defineMessages } from 'react-intl';

export default defineMessages({
    loading: {
        id: 'ml.policychange.yourPolicies.loading',
        defaultMessage: 'Loading...'
    },
    saving: {
        id: 'ml.policychange.yourPolicies.saving',
        defaultMessage: 'Saving...'
    },
    makeChanges: {
        id: 'ml.policychange.yourPolicies.makeChanges',
        defaultMessage: 'Make Changes'
    },
    nextBaseDescription: {
        id: 'ml.policychange.yourPolicies.nextBaseDescription',
        defaultMessage: 'We\'ll check if {bold} next'
    },
    nextDescriptionBold: {
        id: 'ml.policychange.yourPolicies.nextDescriptionBold',
        defaultMessage: 'additional changes are needed'
    },
    addPolicy: {
        id: 'ml.policychange.businessActivity.Add policy',
        defaultMessage: 'Add policy'
    },
    editPolicy: {
        id: 'ml.policychange.businessActivity.Edit policy',
        defaultMessage: 'Edit policy'
    }
    
});
